import { Device } from "@capacitor/device";
import { PREVIEW_MODE } from "./local";

export let API_BASE_URL = "https://plii.app"; // Default to production

export const configureApiBaseUrl = async () => {
  const info = await Device.getInfo();
  const host = window.location.hostname;

  if (info.platform === "web") {
    if (host === "localhost") {
      API_BASE_URL = "http://localhost:8080";
    } else if (PREVIEW_MODE) {
      API_BASE_URL = "https://preview-plii.web.app";
    }
  } else if (info.platform === "ios" || info.platform === "android") {
    if (PREVIEW_MODE) {
      API_BASE_URL = "https://preview-plii.web.app";
    } else if (info.isVirtual) {
      API_BASE_URL = "https://ccfb-24-193-4-218.ngrok-free.app";
      // API_BASE_URL = "http://192.168.87.22:8080"; // local dev on simulator
    }
  }

  console.log(`Configured API_BASE_URL: ${API_BASE_URL}`);
  return API_BASE_URL;
};
